import { http } from "..";
import { queryBuilder } from "../../utils/helper";

/**
 * Search user in school
 *
 * @returns axios http response
 */
export const searchUserInSchool = (filter:any) => {
  const query = queryBuilder(filter)
  return http.get(`/schools/search-user/${query}`);
};
